
class CapSubmitStudentNotes {
  constructor(config) {
    this.config = config
  }
  
  // eslint-disable-next-line
  checkPermission(options = {}) {
    return Boolean(this.config)
  }
}

function key() {
  return 'submit_student_notes'
}

function create(config) {
  return new CapSubmitStudentNotes(config)
}

export default {
  key,
  create,
}
